
import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[OnlyNumber]'
})
export class OnlyNumber {

  constructor(private el: ElementRef) { }
 regexStr = '2';
  @Input() OnlyNumber: boolean;

 @HostListener('keydown', ['$event']) onKeyDown(event:any) {
    let e = <KeyboardEvent> event;
    if (this.OnlyNumber) {
        if ((event.keyCode == 48) 
        || (event.keyCode == 57) || (!event.shiftKey && event.keyCode == 189) 
        || (!event.shiftKey && event.keyCode >=49 && event.keyCode <56)
        || (!event.shiftKey && event.keyCode >=96 && event.keyCode <105)
        || (event.shiftKey && event.keyCode == 187)
        || (event.ctrlKey && event.keyCode == 65)
        || event.keyCode == 107 || event.keyCode == 109
        || event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39
        || event.keyCode == 9 || (event.shiftKey && event.keyCode == 9)) {
          // let it happen, don't do anything
          return;
        } 

      
      else
        e.preventDefault();
      }
  }
}


/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/


// WEBPACK FOOTER //
// ./src/app/customerservice/directive/only-number-specialcharacter.directive.ts